"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bullet = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = _styledComponents["default"].nav.withConfig({
  displayName: "Bulletsstyle__Container",
  componentId: "tmn8d1-0"
})({
  width: '100%',
  textAlign: 'center',
  ol: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    fontSize: 0
  },
  li: {
    display: 'inline-block'
  }
});

exports.Container = Container;

var Bullet = _styledComponents["default"].button.withConfig({
  displayName: "Bulletsstyle__Bullet",
  componentId: "tmn8d1-1"
})(function (_ref) {
  var _ref$theme = _ref.theme,
      color = _ref$theme.color,
      spacing = _ref$theme.spacing,
      active = _ref.active;
  return {
    background: 'transparent',
    position: 'relative',
    border: 0,
    width: spacing.inline.xl,
    height: spacing.inline.xl,
    cursor: 'pointer',
    outline: 'none',
    padding: 0,
    ':before, :after': {
      transition: '0.2s',
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '50%',
      top: '50%'
    },
    // ring
    ':before': {
      transform: "translate(-50%, -50%) ".concat(active ? 'scale(1)' : 'scale(0.7)'),
      borderRadius: '50%',
      border: '1px solid',
      borderColor: active ? color.brandPrimary.light : 'transparent',
      width: spacing.inline['3xs'],
      height: spacing.inline['3xs']
    },
    // dot
    ':after': {
      background: active ? color.brandPrimary.light : color.neutral['04'],
      transform: "translate(-50%, -50%) ".concat(active ? 'scale(1.3)' : 'scale(1)'),
      borderRadius: '50%',
      width: spacing.inline['5xs'],
      height: spacing.inline['5xs']
    },
    ':hover, :focus': {
      ':after': {
        background: color.brandPrimary.light
      }
    }
  };
});

exports.Bullet = Bullet;